<template>
  <popup-window v-slot="scope" ref="popupWindow" :can-close="canClose">
    <span
      v-if="canClose"
      style="text-align: right; margin-top: -1rem; width: 100%"
    >
      <button
        style="cursor: pointer; margin-top: -2rem; padding: 1rem"
        @click="scope.close"
      >
        X
      </button>
    </span>
    <h2 class="title title-l">
      {{ reasonCode === "already_claimed" ? "Oeps!" : "Helaas!" }}
    </h2>
    <p>
      {{ reason }}
    </p>
    <div class="buttons">
      <a class="button--primary" @click="scope.close">Sluiten</a>
    </div>
  </popup-window>
</template>

<script>
import EventBus from "./../event-bus";

export default {
  name: "PopupAvailabilityCheck",
  props: {
    open: {
      type: Boolean,
      default: false,
      required: false,
    },
    canClose: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      reason: "",
      reasonCode: null,
    };
  },
  mounted() {
    EventBus.$on("openPopupAvailabilityCheck", ({ reason, reasonCode }) => {
      console.log(reason);
      this.reason = reason;
      this.reasonCode = reasonCode;
      this.$refs.popupWindow.openPopUp();
    });
    if (this.open) {
      this.$refs.popupWindow.openPopUp();
    }
  },
  methods: {},
};
</script>
